var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn btn-sm btn-facebook rounded-pill btn-block text-white",on:{"click":function($event){return _vm.doLoginFb()}}},[_c('i',{staticClass:"fab fa-facebook-f mr-1"}),_vm._v(" Facebook ")])}
var staticRenderFns = []

export { render, staticRenderFns }